<footer class="p-4 flex">
  <a class="px-2 text-cyan hover:opacity-80"
     href="https://github.com/aritchie05/EcoCraftingTool"
     target="_blank">{{ message('sourceCodeLink') }}</a>
  <span class="opacity-50">|</span>
  <a class="px-2 text-cyan hover:opacity-80"
     href="https://github.com/aritchie05/EcoCraftingTool/issues"
     target="_blank">{{ message('feedbackLink') }}</a>
  <span class="opacity-50">|</span>
  <a class="px-2 text-cyan hover:opacity-80"
     href="https://github.com/aritchie05"
     target="_blank">{{ message('authorLink') }}</a>
  <span class="opacity-50">|</span>
  <a class="px-2 text-cyan hover:opacity-80"
     href="https://eco-farming-tracker.vercel.app"
     target="_blank">{{ message('farmingTrackerLink') }}</a>
</footer>
